import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import {
    getRoom, BESIDA_ROLE_BUYER
} from '@evo/chat-core';
import { t } from 'c-3po';
import { Config } from '../../../../../../../../chat-prom-desktop/src/core/config';
import * as a from '../../../../../../libs/actions';
import {
    getSocketStore,
    findObjInArr,
    objectValues
} from '../../../../../../libs/utils';
import { toJS } from '../../../../../helpers/ImmutableToJS';

import { Button } from '../../../../../ui/button';

// styles
import css from './banNotification.sss';


class CompanyBanView extends React.Component {
    static propTypes = {
        clientBanned: PropTypes.bool,
    };

    handleGetClientInfo = (ident) => {
        return (ev) => {
            ev.preventDefault();
            this.props.send(a.EVENT_CLIENT_SHOW_INFO, { ident });
        };
    }

    render() {
        const { clientBanned, chatUsers, companyBannedSKK } = this.props;
        const { CURRENT_DOMAIN, CORE_BANNED_SKK_NOTIFICATION } = Config.data.appState;

        const buyer = findObjInArr(objectValues(chatUsers),
            (obj) => obj.role === BESIDA_ROLE_BUYER
        );

        let banMsg;
        if (clientBanned) {
            banMsg = (
                <React.Fragment>
                    <div className={css.text}>
                        {t`Покупатель заблокирован`}
                    </div>
                    <Button
                        typeContour
                        dataQa='unban_btn'
                        onClick={this.handleGetClientInfo(buyer.ident)}
                    >
                        {t`Разблокировать`}
                    </Button>
                </React.Fragment>
            )
        }
        else if (companyBannedSKK && CORE_BANNED_SKK_NOTIFICATION) {
            banMsg = (
                <React.Fragment>
                    <div className={css.text}>
                        {t`Доступ заблокирован. Ваша компания проходит
                        проверку Службой контроля качества ${CURRENT_DOMAIN}.`}
                    </div>
                </React.Fragment>
            )
        }
        else {
            banMsg = (
                <div className={css.text}>
                    {t`Ваш магазин заблокирован покупателем.
                 Вы не можете отправлять ему сообщения.`}
                </div>
            );
        }

        return (
            <React.Fragment>
                {banMsg}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);
    const currentChatRoom = getRoom(socketStore, state.get('openedRoomIdent'));
    const companyBannedSKK = currentChatRoom.getIn(['extra', 'is_banned_skk']);

    return {
        clientBanned: currentChatRoom.get('clientBanned'),
        chatUsers: currentChatRoom.get('users'),
        locale: state.get('locale'),
        companyBannedSKK,
    };
};

export const CompanyBan = connect(mapStateToProps)(toJS(CompanyBanView));

